import { Header, VStack } from 'tio-ui/components/layout';
import AlertBanner from 'tio-ui/components/alert-banner';
import t from 'ember-intl/helpers/t';

<template>
  <VStack>
    <AlertBanner @intent="info" data-test-sf-0726-bill-alert>
      <h2 class="text-base">
        <strong>{{t "strategy_finder_0726.bill_alert.header"}}</strong>
      </h2>
      <p>{{t "strategy_finder_0726.bill_alert.body"}}</p>
    </AlertBanner>
    <Header>{{t "strategy_finder_0726.title"}}</Header>
    {{outlet}}
  </VStack>
</template>
